
import { defineComponent } from 'vue'

export default defineComponent({
  data() {
    return {
      items: [
        { key: 'routine', icon: 'magic' },
        { key: 'insights', icon: 'chart-line' },
        { key: 'next', icon: 'lightbulb' },
      ],
    }
  },
})
